// Import model
import { OtgItemCost } from '../models/OtgItemCost';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgItemCost - handles JSON serialization and deserialization with type validation
 */
export class OtgItemCostSerializer {
  /**
   * Deserializes a JSON string into a OtgItemCost instance
   */
  static deserialize(json: string): OtgItemCost {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgItemCost instance
   */
  static fromObject(obj: any): OtgItemCost {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgItemCost');
    }


    const instance: OtgItemCost = {
      locationId: obj['locationId'] as string | undefined,
      minQuantity: obj['minQuantity'] as number | undefined,
      packageCondition: obj['packageCondition'] as string | undefined,
      priceCriteria: obj['priceCriteria'] as string | undefined,
      promotion: obj['promotion'] as string | undefined,
      uom: obj['uom'] as string | undefined,
      unitCost: obj['unitCost'] as number | undefined,
      droppedDate: obj['droppedDate'] as string | undefined,
      effectiveDate: obj['effectiveDate'] as string | undefined,
      pendingDate: obj['pendingDate'] as string | undefined,
      promotionalEnd: obj['promotionalEnd'] as string | undefined,
      promotionalStart: obj['promotionalStart'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgItemCost instances
   */
  static deserializeArray(json: string): OtgItemCost[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgItemCost instance to a JSON string
   */
  static serialize(instance: OtgItemCost): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgItemCost instance to a plain object
   */
  static toObject(instance: OtgItemCost): any {
    return {
      'locationId': instance.locationId,
      'minQuantity': instance.minQuantity,
      'packageCondition': instance.packageCondition,
      'priceCriteria': instance.priceCriteria,
      'promotion': instance.promotion,
      'uom': instance.uom,
      'unitCost': instance.unitCost,
      'droppedDate': instance.droppedDate,
      'effectiveDate': instance.effectiveDate,
      'pendingDate': instance.pendingDate,
      'promotionalEnd': instance.promotionalEnd,
      'promotionalStart': instance.promotionalStart,
    };
  }

  /**
   * Serializes an array of OtgItemCost instances to a JSON string
   */
  static serializeArray(instances: OtgItemCost[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
